import { generateTimestamps } from "./generateTimestamps";
import { generateZonedTimeframe } from "common/helpers/dateAndTimeHelpersV2";

export const generateDemoData = (props?: Record<string, unknown>): Record<string, unknown>[] => {

  const {
    groups = ['group_1', 'group_2', 'group_3'],
    grouping_key = 'group',
    timestamp_key = 'timestamp',
    totals_key = 'value',
    interval = '1 minutes',
    business_hours_only = true,
    weekday_only = false,
    count_key,
    days = 7 
  } = props || {}
  
  const colors = {}

  const value_keys = props?.value_keys || [totals_key]
  
  const { startTime, endTime } = generateZonedTimeframe('UTC', { subtractDays: days })
  const timestamps = generateTimestamps(startTime,  endTime, interval as string)
  const demo_data = []
  
  const start_time = new Date(timestamps[0]).toISOString()
  const end_time = new Date(timestamps[timestamps.length - 1]).toISOString()

  // Initialize base values and previous values per key
  const baseValues: Record<string, number> = {}
  const prevValues: Record<string, number> = {}
  
  value_keys.forEach((k) => {
    const base = Math.floor(Math.random() * 80) + 20 // base between 20-100
    baseValues[k] = base
    prevValues[k] = base
  })

  for (let i = 0; i < timestamps.length; i++) {
    const group = groups[Math.floor(Math.random() * groups.length)]
   
    let new_item = {
      [timestamp_key as string]: new Date(timestamps[i]).getTime(),
      [grouping_key as string]: group
    }

    if (!colors?.[group]) {
      colors[group] = `hsl(${Math.floor(Math.random() * 360)}, 70%, 50%)`
    }

    new_item = {...new_item, color: colors[group]}
    
    if (count_key) new_item[count_key as string] = 0

    value_keys.forEach((k) => {
      const drift = (Math.random() * 0.4 - 0.2) * baseValues[k] // additive noise based on base
      const meanRevert = (baseValues[k] - prevValues[k]) * 0.1 // pull back toward base
      const newValue = Math.max(0, Math.round(prevValues[k] + drift + meanRevert))
      prevValues[k] = newValue
      new_item[k] = newValue
      if (count_key) new_item[count_key as string] += Math.ceil(newValue * .3)
    })

    if (business_hours_only) {
      const tsDate = new Date(new_item[timestamp_key as string])
      const utcDay = tsDate.getUTCDay() // 0=Sun, 1=Mon, ..., 5=Fri, 6=Sat
      const utcHour = tsDate.getUTCHours()
      
      const is_business_hour = (utcDay >= 1 && utcDay <= 5 && utcHour >= 9 && utcHour <= 17) ? true : false // 9am-5pm EST in UTC
      
      if (is_business_hour) {
        value_keys.forEach((k) => {
          new_item[k] = 0       
        })
      }
    }
 
    demo_data.push(new_item)
  }
 
  return {data: demo_data, start_time, end_time, timestamp_key, grouping_key, totals_key, time_interval: interval, count_key, value_key: totals_key }
}